import * as React from "react";
const SvgFiRrStarOfDavid = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="m20.35 12 2.022-3.466a2.32 2.32 0 0 0 .008-2.354A2.33 2.33 0 0 0 20.342 5h-4.076l-2.237-3.834A2.33 2.33 0 0 0 11.999 0c-.845 0-1.604.436-2.03 1.166L7.733 5H3.659c-.852 0-1.613.441-2.038 1.18a2.33 2.33 0 0 0 .008 2.354L3.65 12l-2.022 3.466a2.33 2.33 0 0 0-.008 2.354A2.33 2.33 0 0 0 3.659 19h4.075l2.236 3.834A2.33 2.33 0 0 0 12 24c.845 0 1.604-.436 2.03-1.166L16.267 19h4.076c.852 0 1.614-.441 2.038-1.18a2.33 2.33 0 0 0-.008-2.354zm-.007-5c.176 0 .266.11.303.176a.34.34 0 0 1-.001.35l-1.452 2.49-1.76-3.015zm-2.308 5-2.917 5H8.883l-2.917-5 2.917-5h6.235zm-6.337-9.826A.34.34 0 0 1 12 2c.075 0 .214.022.302.173L13.95 5h-3.902l1.648-2.826M3.356 7.526a.33.33 0 0 1 0-.35A.34.34 0 0 1 3.659 7h2.909l-1.76 3.015zM3.658 17a.34.34 0 0 1-.303-.176.34.34 0 0 1 0-.35l1.452-2.489L6.566 17zm8.644 4.827A.34.34 0 0 1 12 22a.34.34 0 0 1-.302-.174L10.05 19h3.902zm8.344-5.002a.34.34 0 0 1-.303.176h-2.91l1.76-3.015 1.452 2.49a.34.34 0 0 1 0 .349"
    />
  </svg>
);
export default SvgFiRrStarOfDavid;
